import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import { makeStyles } from "tss-react/mui";
import { Table, TableRow, TableHead, TableContainer, Box, Grid, } from "@mui/material";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import Assets from "../../Components/Common/ImageContainer";
import PaperContainer from "../../Components/Common/PaperContainer";
import TableHeading from "../../Components/Common/CommonTableHeading";
import CommonModal from "../../Components/Common/CommonModel";
import { useAppContext } from "../../Context/context";
import axios from "../../APiSetUp/axios";
import swal from "sweetalert";
import { useLocation } from "react-router-dom";
import DataNotFound from "../../Components/Common/DataNotFound";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { lightTheme } from "../../theme";
import { permissionStatus, projectStatus } from "../../Utils/enum";
import WidgetLoader from "../../Components/Common/widgetLoader";
import Swal from "sweetalert2";
import CustomPagination from "../../Components/Common/CustomPagination";
import AddProject from "../../Components/Project";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontWeight: 600,
    fontSize: 14,
    color: theme.palette.primary.main,
    fontFamily: "Poppins",
    padding: 5,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: "Poppins",
    fontWeight: 500,
    padding: "8px",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const useStyles = makeStyles()((theme) => {
  return {
    paddedRow: {
      padding: "15px 10px",
    },
    writeBox: {
      borderRadius: "6px",
      padding: "8px",
      backgroundColor: lightTheme.palette.bgLightExtraPrimary.main,
      color: lightTheme.palette.primary.main,
      cursor: "pointer",
    },
    viewBox: {
      borderRadius: "6px",
      padding: "8px",
      color: lightTheme.palette.bgLightSuccess.main,
      backgroundColor: lightTheme.palette.bgLightExtraSuccess.main,
      cursor: "pointer",
    },
    deleteBox: {
      borderRadius: "6px",
      padding: "8px",
      color: lightTheme.palette.bgLightRed.main,
      backgroundColor: lightTheme.palette.bgLightExtraRed.main,
      cursor: "pointer",
    },
  };
});

const Project = () => {
  const { classes } = useStyles();
  const location = useLocation();
  const { pathname } = location;

  const { OnUpdateError, toggleLoader, menuList } = useAppContext();

  //States
  const [model, setModel] = useState(false);
  const [data, setData] = useState({});
  const [error, setError] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [projectDetails, setProjectDetails] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(1);
  const [permissions, setPermissions] = useState({});
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false)
  const [output, setOutput] = useState("<p><br></p>");


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  //Validation
  const handleValidation = () => {
    let formIsValid = true;
    let errors = {};

    if (!data?.projectName) {
      formIsValid = false;
      errors["projectName"] = "Please enter projectName.";
    }

    if (!data?.totalSite) {
      formIsValid = false;
      errors["totalSite"] = "Please enter totalSite.";
    }

    if (!data?.duration) {
      formIsValid = false;
      errors["duration"] = "Please enter duration.";
    }

    if (!data?.teamMembers) {
      formIsValid = false;
      errors["teamMembers"] = "Please enter teamMembers.";
    }

    if (!output || output === "<p><br></p>") {
      formIsValid = false;
      errors["output"] = "Please enter output.";
    }

    setError(errors);
    return formIsValid;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log("name, value ", name, value)
    setData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const _getProject = () => {
    setLoading(true)
    let body = {
      limit: rowsPerPage,
      page: page,
      search: search || ""
    };
    axios.post(`/project`, body)
      .then((res) => {
        if (res?.data?.data) {
          setProjectDetails(res?.data?.data);
        }
      })
      .catch((err) => {
        OnUpdateError(err.data.message);
      }).finally(() => setLoading(false));
  };

  const handleClear = () => {
    setModel(false);
    setData({});
    setError({});
    setIsEdit(false);
  };

  const _addUpdateProject = () => {
    if (handleValidation()) {
      toggleLoader();
      let body = {
        projectName: data?.projectName,
        totalSite: data?.totalSite,
        duration: data?.duration,
        teamMembers: data?.teamMembers,
      };
      if (output) {
        body.output = output
      }
      if (data?._id) {
        body.id = data?._id;
      }
      axios
        .post(`project/${data?._id ? "update" : "create"}`, body)
        .then((res) => {
          if (res?.data?.data) {
            swal("Success", res?.data?.message, "success");
            handleClear();
            _getProject();
          }
          toggleLoader();
        })
        .catch((err) => {
          toggleLoader();
          OnUpdateError(err.data.message);
        });
    }
  };

  const _handleDelete = (deleteId) => {
    Swal.fire({
      title: "<strong>Warning</strong>",
      icon: "error",
      html: "Are you sure you want to delete project",
      showCancelButton: true,
      confirmButtonColor: "#0492c2",
      iconColor: "#ff0000",
      confirmButtonText: "Yes",
      cancelButtonColor: "#1A1B2F",
    }).then(async (result) => {
      if (result.isConfirmed) {
        toggleLoader();
        axios
          .delete(`/project/delete/${deleteId}`)
          .then((res) => {
            swal("Success", res?.data?.message, "success");
            toggleLoader();
            _getProject();
          })
          .catch((err) => {
            toggleLoader();
            OnUpdateError(err.data.message);
          });
      }
    });
  };

  useEffect(() => {
    _getProject();
  }, [page, rowsPerPage, search]);

  useEffect(() => {
    const menu = menuList?.find((e) => e?.path === pathname);
    if (menu) {
      const menuPermissions = menu.permissions;
      setPermissions({
        view: menuPermissions.includes(permissionStatus.view) ? true : false,
        create: menuPermissions.includes(permissionStatus.create) ? true : false,
        update: menuPermissions.includes(permissionStatus.update) ? true : false,
        delete: menuPermissions.includes(permissionStatus.delete) ? true : false,
      });
    }
  }, [menuList, location]);

  return (
    <>
      <PaperContainer elevation={0} square={false}>
        <Grid container>
          <Grid item xs={12}>
            <TableHeading
              title="Project List"
              buttonText={permissions?.create ? `Add Project` : ""}
              onClick={() => setModel(true)}
              handleSearch={(value) => { setPage(1); setSearch(value); }}
            />
          </Grid>
          <Grid item xs={12}>
            <TableContainer>
              {!loading ? (
                <Table sx={{ minWidth: 600 }} aria-label="customized table">
                  <TableHead>
                    <TableRow>
                      <StyledTableCell className={classes.paddedRow}>No.</StyledTableCell>
                      <StyledTableCell>Project Name</StyledTableCell>
                      <StyledTableCell>Status</StyledTableCell>
                      <StyledTableCell>Team members</StyledTableCell>
                      <StyledTableCell>Duration (in month)</StyledTableCell>
                      <StyledTableCell>Total Site</StyledTableCell>
                      <StyledTableCell>Allocated site</StyledTableCell>
                      <StyledTableCell>Approved site</StyledTableCell>
                      <StyledTableCell>Output</StyledTableCell>
                      <StyledTableCell align="center" >Action</StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {projectDetails?.response?.length > 0 ? projectDetails?.response?.map((row, index) => {
                      const getStatus = (type) => { return projectStatus.filter((e) => e?.id == type)?.[0]?.label; };

                      return (
                        <StyledTableRow key={index}>
                          <StyledTableCell className={classes.paddedRow}>{(index % rowsPerPage) + 1 + (page - 1) * rowsPerPage}</StyledTableCell>
                          <StyledTableCell component="th" scope="row">{row.projectName}</StyledTableCell>
                          <StyledTableCell component="th" scope="row">{getStatus(row.status)}</StyledTableCell>
                          <StyledTableCell component="th" scope="row">{row.teamMembers}</StyledTableCell>
                          <StyledTableCell component="th" scope="row">{`${row?.duration} months`}</StyledTableCell>
                          <StyledTableCell component="th" scope="row">{row.totalSite}</StyledTableCell>
                          <StyledTableCell component="th" scope="row">{row.totalAlloctedSite}</StyledTableCell>
                          <StyledTableCell component="th" scope="row">{row.totalApprovedSite}</StyledTableCell>
                          <StyledTableCell><div dangerouslySetInnerHTML={{ __html: row?.output }} noWrap /></StyledTableCell>
                          <StyledTableCell>
                            <Box display={"flex"} gap={1} justifyContent={"center"} >
                              {permissions?.update && (
                                <Assets
                                  className={classes.writeBox}
                                  src={"/assets/icons/write.svg"}
                                  absolutePath={true}
                                  onClick={() => {
                                    setData(row);
                                    setIsEdit(true);
                                    setModel(true);
                                  }}
                                />
                              )}
                              {permissions?.delete && (
                                <Assets
                                  className={classes.deleteBox}
                                  src={"/assets/icons/delete.svg"}
                                  absolutePath={true}
                                  onClick={() => {
                                    _handleDelete(row?._id);
                                  }}
                                />
                              )}
                            </Box>
                          </StyledTableCell>
                        </StyledTableRow>
                      );
                    }) :
                      <TableRow>
                        <TableCell colSpan={12}> <DataNotFound icon={<ErrorOutlineIcon color="primary" style={{ fontSize: "3rem" }} />} elevation={0} /></TableCell>
                      </TableRow>
                    }
                  </TableBody>
                </Table>
              ) : (
                <WidgetLoader />
              )}
            </TableContainer>
          </Grid>

          {projectDetails?.count > 0 && <Grid item xs={12}>
            <CustomPagination
              rowsPerPageOptions={[5, 10, 25, 50]}
              count={Math.ceil(projectDetails?.count / rowsPerPage)}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage} />
          </Grid>
          }
        </Grid>

      </PaperContainer>

      {model && (
        <CommonModal
          open={model}
          onClose={handleClear}
          title={`${isEdit ? "Update" : "Add"} project`}
          content={
            <AddProject
              data={data}
              setData={setData}
              error={error}
              handleChange={handleChange}
              onSubmit={_addUpdateProject}
              isEdit={isEdit}
              output={output}
              setOutput={setOutput}
            />
          }
        />
      )}
    </>
  );
};

export default Project;
